// ─── Sous-module « core-stockage » ────────────────────────────────
// Upload de fichiers vers Firebase Storage, générique : le module appelant
// choisit son dossier. Renvoie { url, chemin } à ranger dans Firestore.
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

function extension(blob, uri, defaut = 'bin') {
  return blob?.type
    ? (blob.type.split('/')[1]?.split(';')[0] || defaut)
    : (String(uri || '').split('.').pop()?.split('?')[0] || defaut);
}

// `dossier` : chemin logique, ex. `espaces/${tenantId}/inventaire`.
export async function uploadFichier(uri, dossier, { defautExt = 'jpg' } = {}) {
  const reponse = await fetch(uri);
  const blob = await reponse.blob();
  const chemin = `${dossier}/${Date.now()}_${Math.random().toString(36).slice(2, 7)}.${extension(blob, uri, defautExt)}`;
  const r = ref(storage, chemin);
  await uploadBytes(r, blob);
  const url = await getDownloadURL(r);
  return { url, chemin };
}

export async function supprimerFichier(chemin) {
  if (!chemin) return;
  try { await deleteObject(ref(storage, chemin)); } catch (_) { /* déjà supprimé */ }
}
